module.exports = __webpack_public_path__ + "img/ministry-of-education.a7df5d58.webp";